import { z } from "zod";
export const SHORT_PERSISTENT_ID_LENGTH = 8;
export function tryParseShortPersistentId(url = "/") {
    var _a;
    const lastUrlPart = url.split("/").pop() || "";
    const shortPersistentId = ((_a = lastUrlPart.split("-").pop()) === null || _a === void 0 ? void 0 : _a.replaceAll(".html", "")) || null;
    return (shortPersistentId === null || shortPersistentId === void 0 ? void 0 : shortPersistentId.length) === SHORT_PERSISTENT_ID_LENGTH
        ? shortPersistentId
        : null;
}
export const PublishedDocPage = z.object({
    id: z.string(),
    publishedDocId: z.string(),
    pageShortPersistentId: z.string(),
    pagePersistentId: z.string().optional(),
    pathV1: z.string(),
    pathV2: z.string(),
    storagePath: z.string(),
    locale: z.string().optional(),
    isPrivate: z.boolean(),
    isHidden: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
